import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const cancelFunding = createApiThunk<void, string>(
  "fundingRequests/cancelFunding",
  async (fundingRequestId, { extra: { adminRepository } }) => {
    return adminRepository!.cancelFunding(fundingRequestId);
  },
);

export const resetCancelFunding = createAction("fundingRequests/resetCancelFunding");
